import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import checkout from "../imgs/checkout.svg"
import notificationsBlue from "../imgs/notifications-blue.svg"
import notifications from "../imgs/notifications.svg"
import { SingleNotification } from "../pages/notifications/components/_NotificationsList"
import NotificationStore from "../stores/notifications"
import { Subscribe } from "unstated"
import loadingSpinner from "../imgs/loading-spinner.svg"

const TopNotificationMenu = styled.div`
  .notification-div-child-wrapper {
    min-width: 80px;
    padding: 18px 0;
  }

  .notification-div-child {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
  }

  .notification-div-child-logo {
    cursor: pointer;
    background-color: transparent;
    box-shadow: 0 0 0 2px ${props => props.color} inset;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-right: 10px;
    width: 31px;
    height: 31px;
    min-width: 31px;
    min-height: 31px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    user-select: none;
    transition: background-color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      box-shadow 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    overflow: visible;
  }

  .mdcl-child {
    width: 31px;
    height: 31px;
    min-width: 31px;
    min-height: 31px;
    position: relative;
    user-select: none;
    transition: color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      fill 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    display: flex !important;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .mdcl-child-img {
    display: block;
  }

  .nav-child-dialog {
    position: absolute;
    top: 66px;
    width: 420px;
    border: 1px solid #f1f1f1;
    background: #ffffff;
    padding: 32px 0;
    box-shadow: 0px 12px 40px rgba(110, 133, 155, 0.12);
    transform: translateX(-45%);
  }
  .nav-child-dialog-inner {
    max-height: 500px;
    overflow-y: scroll;
    padding: 0 32px;
  }

  .column-title-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
    .title {
      font-size: 18px;
      font-weight: 400;
      line-height: 22px;
      color: #0e1616;
    }
    .subtitle {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #0e1616;
    }
    .action-button {
      color: #667af4;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .button-text {
        line-height: 17px;
        margin-left: 5px;
      }
      .link {
        text-decoration: none;
        color: ${props => props.color};
        border-bottom: 1px solid #667af4;
      }
    }
  }
  .title-header {
    margin-bottom: 24px;
  }
  .unread-dot {
    width: 10px;
    height: 10px;
    background-color: #667af4;
    position: absolute;
    border-radius: 50%;
    top: 0;
    right: 0;
    z-index: 2;
  }
`

export const NotificationMenu = ({ location }) => {
  const navDialogRef = useRef(null)
  const [openNavDialog, setOpenNavDialog] = useState(false)
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        navDialogRef.current &&
        !navDialogRef.current.contains(event.target)
      ) {
        setOpenNavDialog(false)
      }
    }
    document.addEventListener("click", handleClickOutside, true)
    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [])
  return (
    <TopNotificationMenu
      color={
        location.pathname.match("/notifications") || openNavDialog
          ? "#667af4"
          : "#9ba1aa"
      }
      ref={navDialogRef}
    >
      <Subscribe to={[NotificationStore]}>
        {notificationStore => (
          <div
            className="notification-div-child-wrapper"
            onMouseEnter={() => {
              if (!location.pathname.match("/notifications")) {
                setOpenNavDialog(true)
                notificationStore.setState({ hasUnread: false })
              }
            }}
            onMouseLeave={() => {
              if (!location.pathname.match("/notifications")) {
                setOpenNavDialog(false)
              }
            }}
          >
            <div
              className="notification-div-child"
              onClick={() => {
                if (!location.pathname.match("/notifications")) {
                  setOpenNavDialog(!openNavDialog)
                  notificationStore.setState({ hasUnread: false })
                }
              }}
            >
              <div className="notification-div-child-logo">
                <div className="mdcl-child">
                  <img
                    className="mdcl-child-img"
                    src={
                      location.pathname.match("notifications") || openNavDialog
                        ? notificationsBlue
                        : notifications
                    }
                    alt="notifications-sign"
                  />
                </div>
                {notificationStore && notificationStore.state.hasUnread && (
                  <div className="unread-dot" />
                )}
              </div>
            </div>
            {openNavDialog && (
              <div className="nav-child-dialog">
                <div className="nav-child-dialog-inner">
                  <NotificationMenuContent store={notificationStore} />
                </div>
              </div>
            )}
          </div>
        )}
      </Subscribe>
    </TopNotificationMenu>
  )
}

export const NotificationMenuContent = ({ store }) => {
  const {
    fetchNotifications,
    state: { notifications, loading },
    markAllAsReadNotification,
  } = store

  useEffect(() => {
    fetchNotifications(1, 5)
  }, [fetchNotifications])

  return (
    <div className="columns-wrapper">
      <div className="single-column">
        <div className="column-header">
          <div className="column-title-actions title-header">
            <div className="title">NOTIFICATIONS</div>
            <div className="action-button" onClick={markAllAsReadNotification}>
              <img className="button-img" src={checkout} alt="checkout-img" />
              <span className="button-text">Mark as Read</span>
            </div>
          </div>
          <div className="column-title-actions">
            <div className="subtitle">EARLIER</div>
            <div className="action-button">
              <Link to={"/notifications"} className="button-text link">
                See All
              </Link>
            </div>
          </div>
        </div>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <img
              src={loadingSpinner}
              alt="spinner"
              style={{ width: "50px", height: "50px" }}
            />
          </div>
        ) : (
          notifications.map((notification, idx) => (
            <SingleNotification
              notification={notification}
              isPopUp={true}
              showRighIcon={true}
              key={notification.id || idx}
            />
          ))
        )}
      </div>
    </div>
  )
}
